var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 32.1953,
    width: 47,
    height: 47,
    rx: 5,
    transform: "rotate(-46.2046 -2 32.1953)",
    fill: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDia);
export default __webpack_public_path__ + "static/media/dia.fcc85df260cba354b53e8875e3d7bc57.svg";
export { ForwardRef as ReactComponent };